module.exports = __webpack_public_path__ + "img/aqs_img_04.19688a1d.jpg";